import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import Loader from "../../../../components/Loader.jsx";
import {
  SOCIAL_PLATFORM_RATINGS_URL,
  shouldShowPlatformRatingRoute,
} from "../../../../constants/platformRatings.js";
import { useResponsive } from "../../../../hooks/useResponsive.js";

const PlatformRating = () => {
  const navigate = useNavigate();
  const { userDetails } = useSelector((state) => state.user);
  const { isMobile } = useResponsive();
  const [iframeLoading, setIframeLoading] = useState(true);

  const canView = shouldShowPlatformRatingRoute(userDetails);

  useEffect(() => {
    if (userDetails?._id && !canView) {
      navigate("/dashboard", { replace: true });
    }
  }, [userDetails?._id, canView, navigate]);

  if (!userDetails?._id) return <Loader />;

  if (!canView) return null;

  return (
    <div
      className={`relative w-full overflow-hidden rounded-xl border border-[#E8E8E8] bg-white ${
        isMobile ? "h-[calc(100dvh-200px)] min-h-[320px]" : "h-[calc(100vh-150px)]"
      }`}
    >
      {iframeLoading && (
        <div className="absolute inset-0 z-10 flex items-center justify-center bg-white/80">
          <Loader />
        </div>
      )}
      <iframe
        src={SOCIAL_PLATFORM_RATINGS_URL}
        title="Platform ratings"
        frameBorder="0"
        width="100%"
        height="100%"
        className="border-0"
        onLoad={() => setIframeLoading(false)}
      />
    </div>
  );
};

export default PlatformRating;
